<template>
  <div class="input_box">
    <input
      v-bind="$attrs"
      v-model="val"
      ref="Input"
      @input="inputChange(false)"
      type="number"
    />
    <div class="errorMessage" v-show="errorMessage">{{ errorMessage }}</div>
  </div>
</template>

<script>
export default {
  name: 'Input',
  data() {
    return {
      val: '',
      errorMessage: '',
    };
  },
  props: ['type', 'value', 'setValue', 'getValue'],
  watch: {
    setValue(newVal) {
      this.val = newVal;
      this.inputChange(true);
    },
  },
  methods: {
    inputChange(judge) {
      if (!judge) {
        this.val = this.$refs.Input.value.replace(/^([0-9]*)\.([0-9]{2}).*$/, '$1.$2')
          || parseFloat(this.val);
      }
      const flag = this.value ? this.val * 1 > this.value * 1 : false;
      if (this.value) {
        if (this.value * 1 < 100) {
          if (flag) {
            this.errorMessage = '输入金额超过可转出金额';
            this.getValue('');
          } else if (this.val < 100) {
            this.errorMessage = '转出的金额不能小于100元';
            this.getValue('');
          } else {
            this.errorMessage = '';
            this.getValue(this.val);
          }
        } else if (this.val < 100) {
          this.errorMessage = '转出的金额不能小于100元';
          this.getValue('');
        } else if (flag) {
          this.errorMessage = '输出金额超过可转出金额';
          this.getValue('');
        } else {
          this.errorMessage = '';
          this.getValue(this.val);
        }
      } else if (this.val < 100) {
        this.errorMessage = '转入的金额不能小于100元';
        this.getValue('');
      } else {
        this.errorMessage = '';
        this.getValue(this.val);
      }
    },
  },
};
</script>
<style scoped>
.input_box {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: left;
  padding-bottom: 10px;
}
.input_box input {
  width: 200px;
  border: none;
  font-size: 20px;
  margin-left: 8px;
}
.errorMessage {
  position: absolute;
  left: 47px;
  bottom: -1px;
  color: #ff6538;
  font-size: 12px;
  text-align: left;
}
</style>
